module.exports = __webpack_public_path__ + "static/2.2_the_earliest_human_societies-a805557664852eb3bd3f2e6e5ce46a0f.pdf";